<template>
	<el-table border highlight-current-row stripe v-bind="$attrs" :height="t_height" v-on="$listeners" :data="res.rows" :show-summary="showSummary" :summary-method="showSummary?summary(res.summary):null" header-cell-class-name="table-header" ref="mm_table">
        <slot name="default" :renderHeaderCopy="renderHeaderCopy" :renderHeaderCopyNew="renderHeaderCopyNew" />
	</el-table>
</template>
<script>
export default {
	data() {
		return {
			t_height: 700,
		}
	},
	props:{
		res:{
			type:Object,
			required:true,
		},
		showSummary:{
			type:Boolean,
			default(){return false}
		},
	},
	watch:{
		res(rows){
			this.$forceUpdate();
		}
	},
	methods:{
		summary(summary){
			return function({ columns, data }){
				return columns.map(function(column){
					if (parseFloat(summary[column.property]) || parseFloat(summary[column.property])=== 0){
						if (/\//.test(summary[column.property])) {
							return summary[column.property].replace('.00','');
						}
						if(/%/.test(summary[column.property])){
							return summary[column.property]
						}
						return parseFloat(summary[column.property]).toFixed(2).replace('.00','');
					}else{
						return '--'
					}
				})
			}
		},
		getSummary(field){
			return this.res.summary[field];
		},
		renderHeaderCopyNew(str) {
			const _this = this;
				return function(h, { column }) {

					return h('div',[
					h('span', column.label),
					h('el-button', {
						props: {
							type: 'text',
						},
						on: {
							click: async function() {
								const arr = _this.res.rows.filter((row) => {
									if (_this.$refs.mm_table.selection && _this.$refs.mm_table.selection.length) {
										const list = _this.$refs.mm_table.selection.map((info) => {
											return info[column.property];
										})
										if (!list.includes(row[column.property])) {
											return false;
										}
									}
									return true;
								}).map((row) => {
									return row[column.property];
								})
								let text = arr.join(str);
								
								await _this.$copyText((text));
								_this.$message({
									type:'success',
									message:`Copied ${column.label} success`,
								})
							},
						}
					}, [
						h('i', {
							class: "el-icon-edit",
							style: "margin-left:10px"
						})
					])
				]);
			}
		},
		renderHeaderCopy(h, { column }) {
			const _this = this;
			return h('div',[
				h('span', column.label),
				h('el-button', {
					props: {
						type: 'text',
					},
					on: {
						click: async function() {
							const arr = _this.res.rows.filter((row) => {
								if (_this.$refs.mm_table.selection && _this.$refs.mm_table.selection.length) {
									const list = _this.$refs.mm_table.selection.map((info) => {
										return info[column.property];
									})
									if (!list.includes(row[column.property])) {
										return false;
									}
								}
								return true;
							}).map((row) => {
								return row[column.property];
							})
							let text = arr.join(`,`);
							
							await _this.$copyText((text));
							_this.$message({
								type:'success',
								message:`Copied ${column.label} success`,
							})
						},
					}
				}, [
					h('i', {
						class: "el-icon-edit",
						style: "margin-left:10px"
					})
				])
			]);
		},
	},
	provide(){
		const self = this;
		return {
			getSummary(field){
				if(self.res.summary&&self.res.summary[field]) {
					return self.res.summary[field];
				}
				return '';
			}
		}
	},
	mounted() {
		if (this.$cache.browse_model !== 'phone') {
			this.t_height = '100%';
		}
	}
}
</script>
